// import {
//   circularXXWebBoldWoff,
//   circularXXWebMediumWoff,
//   circularXXWebRegularWoff,
// } from '';
// Font files can be colocated inside of `pages`
import { createMuiTheme } from '@material-ui/core';
import palette from './palette';

const theme = createMuiTheme();

const appTheme = createMuiTheme({
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
  palette,
  typography: {
    fontSize: 16,
    htmlFontSize: 16,
    fontFamily: ['CircularXXWeb-Regular', 'sans-serif'].join(','),
    h1: {
      fontFamily: ['CircularXXWeb-Regular', 'sans-serif'].join(','),
    },
    h5: {
      fontFamily: ['CircularXXWeb-Regular', 'sans-serif'].join(','),
    },
    h6: {
      fontFamily: ['CircularXXWeb-Regular', 'sans-serif'].join(','),
    },
    button: {
      fontFamily: ['CircularXXWeb-Regular', 'sans-serif'].join(','),
      textTransform: 'none',
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '*::-webkit-scrollbar': {
          display: 'none'
        }
        // '@font-face': [
        //   'circularXXWebBoldWoff',
        //   'circularXXWebMediumWoff',
        //   'circularXXWebRegularWoff',
        // ],
      },
    },
    MuiButton: {
      root: {
        fontSize: '15px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '24px',

        '&.Mui-disabled': {
          '&.expansion-panel-button': {
            color: 'rgba(97, 64, 255, 0.26)',
          },
        },
      },
      containedPrimary: {
        '&.error': {
          backgroundColor: '#EF4445',
        },
      },
    },
    MuiPaper: {
      root: {
        background: palette.bianca,
      },
    },
    MuiExpansionPanel: {
      root: {
        '&::before': {
          boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.04)',
        },
        '&.Mui-expanded': {
          margin: 0,
        },
        '& .MuiPaper-root': {
          backgroundColor: palette.bianca,
        },
        '&.MuiPaper-elevation1': {
          boxShadow: 'none',
        },
      },
    },
    MuiExpansionPanelDetails: {
      root: {
        background: '#FEFAF5',

        '& .MuiTypography-h6': {
          color: '#000000',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 'normal',
          lineHeight: '32px',
          opacity: '0.64',
        },
      },
    },
    MuiExpansionPanelSummary: {
      root: {
        background: '#FEFAF5',

        '& .MuiButton-outlinedSizeSmall': {
          padding: 0,
          minWidth: 40,
          minHeight: 40,
          '& .MuiSvgIcon-fontSizeLarge': {
            fontSize: 30,
          },
        },
        '& .MuiTypography-h6': {
          color: '#000000',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 'normal',
          lineHeight: '32px',
          opacity: '0.64',
        },
      },
      content: {
        flexDirection: 'column',
        '& .MuiTypography-h5': {
          color: palette.text.primary,
          display: 'block',
          lineHeight: '32px',
          fontSize: '18px',
        },
        '& .MuiTypography-h6': {
          color: palette.text.primary,
          display: 'block',
          lineHeight: '32px',
          opacity: 0.6,
          fontSize: '16px',
        },
      },
      expandIcon: {
        transform: 'none !important',
      },
    },
    MuiDialog: {
      root: {
        '&.share-dialog': {
          '& .MuiDialog-paper': {
            maxWidth: 672,
          },
        },
      },
      paper: {
        borderRadius: 16,
        backgroundColor: '#FEFAF5',
      },
    },
    MuiDialogTitle: {
      root: {
        padding: '35px 16px 24px',
        textAlign: 'center',

        '& .back-button': {
          top: '8px',
          left: '8px',
          color: palette.primary.main,
          position: 'absolute',
        },

        '& .close-button': {
          position: 'absolute',
          right: 8,
          top: 8,
          color: palette.grey[500],
        },
        '&.upgrade-modal-top': {
          background: '#100B2B',
          color: '#fff',
          fontSize: 18,
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '48px',
          padding: 32,
          textAlign: 'left',

          '& .highlited': {
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '20px',
            lineHeight: '48px',
          },
          '& .opacity': {
            opacity: '0.64',
          },
          [theme.breakpoints.up('sm')]: {
            fontSize: 15,

            '& .highlited': {
              fontSize: 18,
            },
          },
        },
      },
    },
    MuiDialogContent: {
      root: {
        padding: '8px 24px',

        [theme.breakpoints.down('xs')]: {
          padding: 8,
        },

        '& .MuiListItemText-primary': {
          fontStyle: 'normal',
          fontWeight: '500',
          fontSize: '18px',
          lineHeight: '32px',
        },
        '& .MuiListItemText-secondary': {
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '16px',
          lineHeight: '24px',
        },

        '& .MuiListItem-secondaryAction': {
          [theme.breakpoints.up('sm')]: {
            paddingRight: '35%',
          },
        },
        '& .MuiListItemSecondaryAction-root': {
          '& .MuiSvgIcon-root': {
            fontSize: 24,
          },
        },
        '&.upgrade-modal-bottom': {
          padding: '32px 32px 0',
          position: 'relative',
          overflow: 'visible',

          '& iframe': {
            height: '50px !important',
            width: '100% !important',
          },
          '& .cfy-field--invalid .cfy-input': {
            color: '#FD5D60 !important',
            borderColor: '#ff4949 !important',
          },

          '& .MuiSnackbar-root': {
            minWidth: '90%',
            position: 'absolute !important',
            top: '-30px',

            '& .MuiAlert-standardError': {
              background: '#EF4445',
              fontStyle: 'normal',
              fontWeight: 'normal',
              fontSize: '15px',
              lineHeight: '16px',
              color: palette.bianca,
              '& .MuiAlert-icon': {
                color: '#FFF',
              },
            },
          },
        },
      },
    },
    MuiDialogActions: {
      root: {
        padding: '16px 24px',
        textAlign: 'center',

        '& button.full-width': {
          fontSize: 17,
          fontStyle: 'normal',
          fontWeight: '500',
          height: 56,
          lineHeight: '24px',
          textAlign: 'center',
          width: '100%',

          '& .MuiButton-endIcon': {
            position: 'absolute',
            right: 24,
          },
        },
        '&.upgrade-modal-actions': {
          padding: 32,
        },
      },
    },
    MuiList: {
      root: {
        '&.features-list': {
          border: '2px solid rgba(0, 0, 0, 0.08)',
          borderRadius: '8px',

          '&.MuiList-padding': {
            padding: 16,
          },
          '& .MuiDivider-middle': {
            background: 'rgba(0, 0, 0, 0.08)',
            height: '2px',
          },
          '& .MuiListItem-root': {
            paddingTop: 8,
            paddingBottom: 8,
            [theme.breakpoints.down('xs')]: {
              display: 'flex',
              flexDirection: 'column',
              paddingLeft: 0,
              paddingRight: 0,
              paddingTop: '16px',
              textAlign: 'center',
            },
            '& .MuiSvgIcon-root': {
              fontSize: 24,
            },
          },
        },
      },
    },
    MuiTypography: {
      root: {
        '&.features-title': {
          color: '#6140FF',
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: 'bold',
          letterSpacing: '0.16em',
          lineHeight: '32px',
          textAlign: 'center',
          textTransform: 'uppercase',
        },
        '&.payment-method': {
          color: palette.common.black,
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: '18px',
          lineHeight: '24px',
        },
        '&.switch': {
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: 15,
          lineHeight: '32px',
        },
        '&.custom-switch': {
          '& label': {
            fontSize: '15px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '32px',
            textAlign: 'right',
          },
        },
      },
    },
    MuiGrid: {
      root: {
        '&.upgrade-modal': {
          fontSize: 18,
        },
        '&.upgrade-modal-top': {
          color: palette.common.white,
          backgroundColor: '#100B2B',
        },
        '&.totals': {
          lineHeight: '25px',
          '@media only screen and (max-width: 600px) and (orientation: portrait)': {
            marginTop: '10px',
          },
          '& .totals-values': {
            textAlign: 'right',
            '@media only screen and (max-width: 600px) and (orientation: portrait)': {
              textAlign: 'left',
              marginTop: '10px',
            },
          },
        },
      },
    },
    MuiInputBase: {
      root: {
        fontSize: 16,
        fontWeight: 'normal',
        lineHeight: '32px',
        '& .MuiOutlinedInput-input.coupon-code': {
          background: '#FFFFFF',
          border: '1px solid #6140FF',
          boxSizing: 'border-box',
          borderRadius: '4px',

          '&.error': {
            background: '#FFFFFF',
            border: '1px solid #EF4445',
            boxSizing: 'border-box',
            borderRadius: '4px',
          },
        },
      },
    },
    MuiFormLabel: {
      root: {
        fontSize: 16,
      },
    },
    MuiSnackbar: {
      root: {},
    },
    MuiSnackbarContent: {
      root: {
        width: '100%',
        '&.variantSuccess': {
          backgroundColor: '#FF6948',
        },
      },
      message: {
        alignItems: 'center',
        color: '#FFFFFF',
        display: 'flex',
        fontSize: '15px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '24px',
        textAlign: 'center',
      },
      action: {
        alignItems: 'center',
        color: '#FFFFFF',
        display: 'flex',
        fontSize: '15px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '24px',
        textAlign: 'center',
        opacity: 0.64,
      },
    },
  },
});

export default appTheme;
